export default {
    // facultyGuidance: [],
    // facultyCoGuidance: [],
    facultyOpinion: []
}